export const routes = [
  {
    path: "/sala-principal/:id/sala-indicadores-municipio",
    component: () => import(/* webpackChunkName: "ur" */ "./components/List"),
    name: "sala.indicadores.municipio.sala-indicadores-municipio",
    meta: {
      requiresAuth: true,
    },
  },
];
